import styled from 'styled-components';

export const DashboardContainer = styled.div`
  background-color: var(--grey);
  color: var(--grey7);
  padding: 2rem;
  text-align: center;

  h1 {
    font-family: var(--headerFont);
    color: var(--yellow5);
    margin-bottom: 2rem;
  }

  .card-container {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }
`;

export const Card = styled.div`
  background-color: var(--grey1);
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const CardLink = styled.a`
  text-decoration: none;
  color: var(--orange2);
  font-weight: bold;
  font-size: 1.2rem;

  &:hover {
    color: var(--yellow5);
  }
`;

export const SidebarContainer = styled.div`
  background-color: var(--grey);
  color: var(--grey7);
  padding: 2rem;
  width: 300px;
  height: 100vh;
  display: flex;
  flex-direction: column;

  h1 {
    font-family: var(--headerFont);
    color: var(--yellow5);
    margin-bottom: 2rem;
  }

  nav {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;
  }
`;

export const SidebarLink = styled.a`
  text-decoration: none;
  color: var(--orange2);
  font-weight: bold;
  font-size: 1.2rem;

  &:hover {
    color: var(--yellow5);
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 2rem;
  background-color: var(--grey);
  color: var(--grey7);

  h1 {
    grid-column: span 2;
    font-family: var(--headerFont);
    color: var(--yellow5);
    margin-bottom: 2rem;
  }

  .courses {
    grid-column: span 2;
    background-color: var(--white);
    padding: 1rem;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    h2 {
      color: var(--orange2);
      margin-bottom: 1rem;
    }

    ul {
      list-style-type: none;
      padding: 0;

      li {
        margin-bottom: 0.5rem;

        a {
          color: var(--grey7);
          text-decoration: none;

          &:hover {
            color: var(--yellow5);
          }
        }
      }
    }
  }
`;

export const GridItem = styled.a`
  background-color: var(--grey1);
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  text-decoration: none;
  color: var(--orange2);
  font-weight: bold;
  font-size: 1.2rem;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    color: var(--yellow5);
  }
`;
